export default __webpack_public_path__ + "static/media/Dialog4.a2e23a14.svg";